/* LFDM — pop-up d'ajout rapide et kit d'essai (page catégorie).
   Les données viennent de <script type="application/json" data-lfdm-cat>
   rendu par la section « LFDM — Cat. grille » : variantes, prix et plan
   d'abonnement réels. Aucun prix n'est écrit ici.
   Le kit d'essai vient de <script type="application/json" data-lfdm-kit>
   rendu par la section « LFDM — Pop-up achat » : une variante par gamme et
   par taille, plus l'état du compte client (connecté, kit déjà utilisé).
   Les visuels de variante viennent de <script type="application/json"
   data-lfdm-vimg> : la vignette suit la variante sélectionnée.

   Le déclencheur peut porter une variante précise (attribut data-qa-variant,
   ou data-uni-variant) : c'est le cas depuis le hub produit, où le QR code
   identifie une variante. La pop-up s'ouvre alors directement sur le bon
   format et la bonne taille. */
(function () {
  var src = document.querySelector('script[data-lfdm-cat]');
  var modal = document.getElementById('lfdmQa');
  if (!src || !modal) return;

  var DATA;
  try { DATA = JSON.parse(src.textContent); } catch (e) { return; }
  var CFG = DATA.cfg || {};
  var PRODUCTS = DATA.products || [];

  var KIT = null;
  var ksrc = document.querySelector('script[data-lfdm-kit]');
  if (ksrc) { try { KIT = JSON.parse(ksrc.textContent); } catch (e) { KIT = null; } }
  var kitOn = !!(KIT && KIT.variants && KIT.variants.length);

  /* visuels de variante : { "<id de variante>": "<url>" } */
  var VIMG = {};
  var isrc = document.querySelector('script[data-lfdm-vimg]');
  if (isrc) { try { VIMG = JSON.parse(isrc.textContent) || {}; } catch (e) { VIMG = {}; } }

  var $ = function (id) { return document.getElementById(id); };
  var eur = function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; };
  var plur = function (w, n) { return n > 1 ? w + 's' : w; };
  var byHandle = function (h) {
    for (var i = 0; i < PRODUCTS.length; i++) if (PRODUCTS[i].h === h) return PRODUCTS[i];
    return null;
  };

  /* ---------- état ---------- */
  var S = { mode: 'one', p: null, offer: 'pack', key: null };

  /* ---------- éléments ---------- */
  var elTabs = $('qaTabs'), elTabOne = $('qaTabOne'), elTabSub = $('qaTabSub');
  var elChoice = $('qaChoice'), elChoiceOpts = $('qaChoiceOpts'), elChoiceLab = $('qaChoiceLab'), elChoiceHint = $('qaChoiceHint');
  var elOffer = $('qaOffer'), elOfferOpts = $('qaOfferOpts'), elOfferLab = $('qaOfferLab'), elOfferHint = $('qaOfferHint');
  var elSizes = $('qaSizes'), elOptLab = $('qaOptLab'), elOptHint = $('qaOptHint'), elNote = $('qaNote');
  var elName = $('qaName'), elGamme = $('qaGamme'), elSub = $('qaSub'), elImg = $('qaImg'), elIcon = $('qaIcon');
  var elSumLab = $('qaSumLab'), elTotal = $('qaTotal'), elUnit = $('qaUnit'), elSave = $('qaSave');
  var elAdd = $('qaAdd'), elMore = $('qaMore'), elMoreLink = $('qaMoreLink');

  /* ---------- helpers de données ---------- */
  function size(p, k) {
    if (!p) return null;
    for (var i = 0; i < p.sizes.length; i++) if (p.sizes[i].k === k) return p.sizes[i];
    return null;
  }
  function hasSub(p) {
    for (var i = 0; i < p.sizes.length; i++) if (p.sizes[i].s && p.sizes[i].s.id) return true;
    return false;
  }
  function hasBundle(p) {
    for (var i = 0; i < p.sizes.length; i++) if (p.sizes[i].b && p.sizes[i].b.id) return true;
    return false;
  }
  function minPrice(p, kind) {
    var m = 0;
    for (var i = 0; i < p.sizes.length; i++) {
      var v = p.sizes[i][kind];
      if (v && v.pr && (m === 0 || v.pr < m)) m = v.pr;
    }
    return m;
  }
  function packLabel(p, sz) {
    var w = p.w || CFG.unitWord || '';
    if (sz && sz.n) return cap(CFG.packWord) + ' de ' + sz.n;
    var mn = 0, mx = 0;
    for (var i = 0; i < p.sizes.length; i++) {
      var n = p.sizes[i].n;
      if (!n) continue;
      if (mn === 0 || n < mn) mn = n;
      if (n > mx) mx = n;
    }
    if (!mn) return cap(CFG.packWord);
    return cap(CFG.packWord) + (mn === mx ? ' de ' + mn : ' de ' + mn + ' à ' + mx) + ' ' + plur(w, mx);
  }
  function bundleUnits(sz) { return sz && sz.n && sz.c ? sz.n * sz.c : 0; }
  function cap(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : ''; }

  /* variante précise demandée par le déclencheur (hub produit) :
     on retrouve la taille et le format correspondants. */
  function selectVariant(p, vid) {
    if (!p || !vid) return false;
    vid = String(vid);
    for (var i = 0; i < p.sizes.length; i++) {
      var s = p.sizes[i];
      if (s.p && s.p.id && String(s.p.id) === vid) { S.key = s.k; S.offer = 'pack'; return true; }
      if (s.b && s.b.id && String(s.b.id) === vid) { S.key = s.k; S.offer = 'bundle'; return true; }
    }
    return false;
  }

  /* ---------- visuel de la variante sélectionnée ---------- */
  function vimg(id) {
    if (!id) return '';
    return VIMG[String(id)] || '';
  }
  /* renvoie le visuel de la variante en cours ; à défaut celui du produit.
     Tant qu'aucune taille n'est choisie, la variante n'est pas déterminée :
     on garde le visuel principal du produit. */
  function curImg() {
    var p = S.p;
    if (!p) return '';
    var sz = size(p, S.key);
    if (S.mode === 'kit') {
      var kv = sz ? kitVariant(p, sz) : null;
      return (kv && vimg(kv.id)) || p.img || '';
    }
    if (sz) {
      var order = (S.mode === 'sub' || S.offer === 'bundle') ? [sz.b, sz.p] : [sz.p, sz.b];
      for (var i = 0; i < order.length; i++) {
        var u = order[i] ? vimg(order[i].id) : '';
        if (u) return u;
      }
    }
    return p.img || '';
  }

  /* ---------- kit d'essai : correspondance gamme + taille ---------- */
  function norm(s) {
    s = String(s == null ? '' : s).toLowerCase();
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) {}
    return s.replace(/[^a-z0-9]/g, '');
  }
  function loose(s) { return norm(s).replace(/s/g, ''); }

  /* la gamme du kit est portée par le métafield custom.kit_gamme du produit
     (repli : métafield gamme, puis titre) */
  function kitGammeOf(p) {
    var m = KIT && KIT.map ? KIT.map[p.h] : '';
    return m || p.g || p.t || '';
  }
  function kitVariant(p, sz) {
    if (!kitOn || !p || !sz) return null;
    var g = kitGammeOf(p), want = String(sz.k), hit = null, soft = null;
    KIT.variants.forEach(function (v) {
      if (!v.av || String(v.k) !== want) return;
      if (!hit && norm(v.g) === norm(g)) hit = v;
      if (!soft && loose(v.g) === loose(g)) soft = v;
    });
    return hit || soft;
  }
  function kitHas(p) {
    if (!p || !p.sizes) return false;
    for (var i = 0; i < p.sizes.length; i++) if (kitVariant(p, p.sizes[i])) return true;
    return false;
  }
  function kitProducts() {
    var out = [];
    PRODUCTS.forEach(function (p) { if (kitHas(p)) out.push(p); });
    return out.length ? out : PRODUCTS;
  }
  function kitBlocked() { return !!(KIT && KIT.used); }
  function kitNeedsLogin() { return !!(KIT && !KIT.logged); }

  /* ---------- rendu ---------- */
  function radio(checked, title, sub, price, fixed) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'qa-opt';
    b.setAttribute('role', 'radio');
    b.setAttribute('aria-checked', checked ? 'true' : 'false');
    if (fixed) b.setAttribute('data-fixed', '');
    b.innerHTML = '<span class="rad"></span><span class="txt"><b></b><small></small></span><span class="pr"></span>';
    b.querySelector('b').textContent = title;
    b.querySelector('small').textContent = sub || '';
    b.querySelector('.pr').textContent = price || '';
    return b;
  }

  function renderChoice() {
    elChoice.hidden = S.mode !== 'kit';
    if (S.mode !== 'kit') return;
    elChoiceLab.textContent = CFG.kitChoiceLabel || 'Gamme';
    elChoiceHint.textContent = CFG.kitNote || '';
    elChoiceOpts.innerHTML = '';
    kitProducts().forEach(function (p) {
      var keys = [];
      p.sizes.forEach(function (s) { if (kitVariant(p, s)) keys.push(s.k); });
      if (!keys.length) keys = p.sizes.map(function (s) { return s.k; });
      var b = radio(S.p === p, p.t, CFG.optName + ' ' + keys.join(', '), '');
      b.addEventListener('click', function () { setProduct(p); render(); });
      elChoiceOpts.appendChild(b);
    });
  }

  function renderOffers() {
    var p = S.p;
    elOfferOpts.innerHTML = '';
    if (S.mode === 'kit') {
      elOfferLab.textContent = CFG.kitQtyLabel || 'Quantité';
      elOfferHint.textContent = '';
      elOfferOpts.appendChild(radio(true, '1 ' + (CFG.kitTitle || 'kit'), CFG.kitNote || '', 'Offert', true));
      return;
    }
    var sz = size(p, S.key);
    if (S.mode === 'sub') {
      elOfferLab.textContent = 'Livraison';
      elOfferHint.textContent = CFG.subNote || '';
      var sp = sz && sz.s && sz.s.pr ? eur(sz.s.pr) : (minPrice(p, 's') ? 'dès ' + eur(minPrice(p, 's')) : '');
      var subTxt = sz && sz.c ? sz.c + ' ' + plur(CFG.packWord, sz.c) : '';
      elOfferOpts.appendChild(radio(true, CFG.bundleLabel || CFG.bundleValue, subTxt, sp, true));
      S.offer = 'bundle';
      return;
    }
    elOfferLab.textContent = 'Format';
    elOfferHint.textContent = '';
    var one = radio(S.offer === 'pack', packLabel(p, sz), '',
      sz ? eur(sz.p.pr) : 'dès ' + eur(minPrice(p, 'p')));
    one.addEventListener('click', function () { S.offer = 'pack'; render(); });
    elOfferOpts.appendChild(one);
    if (hasBundle(p)) {
      var u = bundleUnits(sz);
      var lot = radio(S.offer === 'bundle', CFG.bundleLabel || CFG.bundleValue,
        sz && sz.c ? sz.c + ' ' + plur(CFG.packWord, sz.c) + (u ? ' · ' + u + ' ' + plur(p.w, u) : '') : '',
        sz ? eur(sz.b.pr) : 'dès ' + eur(minPrice(p, 'b')));
      lot.addEventListener('click', function () { S.offer = 'bundle'; render(); });
      elOfferOpts.appendChild(lot);
    }
  }

  function renderSizes() {
    var p = S.p;
    elOptLab.textContent = CFG.optName || 'Taille';
    elSizes.innerHTML = '';
    p.sizes.forEach(function (s) {
      var ok;
      if (S.mode === 'kit') {
        ok = !!kitVariant(p, s);
      } else {
        var v = (S.mode === 'one' && S.offer === 'pack') ? s.p : s.b;
        ok = !!(v && v.id && v.av);
      }
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'qa-sz';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', S.key === s.k ? 'true' : 'false');
      if (!ok) b.disabled = true;
      b.innerHTML = '<b></b><small></small>';
      b.querySelector('b').textContent = s.k;
      b.querySelector('small').textContent = s.r || '';
      if (ok) b.addEventListener('click', function () { S.key = s.k; render(); });
      elSizes.appendChild(b);
    });
    var note = elNote.querySelector('span');
    if (CFG.optNote) { note.textContent = CFG.optNote; elNote.hidden = false; }
    else { elNote.hidden = true; }
    elOptHint.textContent = S.key ? '' : (CFG.chooseLabel || '');
  }

  function renderFoot() {
    var p = S.p, sz = size(p, S.key);
    if (S.mode === 'kit') {
      elSumLab.textContent = CFG.kitTitle || 'Kit d\'essai';
      elSave.textContent = '';
      if (kitBlocked()) {
        elTotal.textContent = '—';
        elUnit.textContent = (KIT && KIT.usedNote) || 'Un seul kit par compte client.';
        elAdd.textContent = (KIT && KIT.usedLabel) || 'Kit d\'essai déjà utilisé';
        elAdd.disabled = true;
        return;
      }
      elTotal.textContent = 'Offert';
      var needs = kitNeedsLogin();
      elUnit.textContent = needs ? ((KIT && KIT.loginNote) || CFG.kitNote || '') : (CFG.kitNote || '');
      elAdd.textContent = S.key
        ? (needs ? ((KIT && KIT.loginLabel) || 'Se connecter pour recevoir le kit')
                 : (CFG.kitAddLabel || 'Ajouter au panier'))
        : (CFG.chooseLabel || 'Choisissez une taille');
      elAdd.disabled = !S.key;
      return;
    }
    var price = 0, lab = '', units = 0;
    if (S.mode === 'sub') {
      lab = CFG.bundleLabel || CFG.bundleValue;
      price = sz && sz.s ? sz.s.pr : 0;
      units = bundleUnits(sz);
    } else if (S.offer === 'bundle') {
      lab = CFG.bundleLabel || CFG.bundleValue;
      price = sz ? sz.b.pr : 0;
      units = bundleUnits(sz);
    } else {
      lab = packLabel(p, sz);
      price = sz ? sz.p.pr : 0;
      units = sz ? sz.n : 0;
    }
    elSumLab.textContent = lab;
    elTotal.textContent = price ? eur(price) + (S.mode === 'sub' ? ' / 4 semaines' : '') : '—';
    elUnit.textContent = (price && units) ? eur(price / units) + ' ' + (CFG.unitPrefix || '') + ' ' + p.w : '';
    var save = '';
    if (S.mode === 'sub' && sz && sz.b && sz.s && sz.b.pr > sz.s.pr) {
      save = '− ' + eur(sz.b.pr - sz.s.pr) + ' par livraison';
    } else if (S.mode === 'one' && S.offer === 'bundle' && sz && sz.c && sz.p && sz.b) {
      var full = sz.p.pr * sz.c;
      if (full > sz.b.pr) save = '− ' + eur(full - sz.b.pr);
    }
    elSave.textContent = save;
    elAdd.textContent = S.key
      ? (S.mode === 'sub' ? (CFG.subAddLabel || 'M\'abonner') : (CFG.addLabel || 'Ajouter au panier')) + ' — ' + eur(price)
      : (CFG.chooseLabel || 'Choisissez une taille');
    elAdd.disabled = !S.key || !price;
  }

  function renderThumb() {
    var im = curImg();
    if (im) {
      if (elImg.getAttribute('src') !== im) elImg.src = im;
      elImg.alt = S.p ? S.p.t : '';
      elImg.hidden = false;
      elIcon.style.display = 'none';
    } else {
      elImg.removeAttribute('src');
      elImg.hidden = true;
      elIcon.style.display = '';
    }
  }

  function render() {
    var p = S.p;
    if (!p) return;
    elName.textContent = S.mode === 'kit' ? (CFG.kitTitle || 'Kit d\'essai') : p.t;
    elGamme.textContent = p.g || '';
    elGamme.parentNode.hidden = !p.g;
    elSub.textContent = p.a || '';

    var showTabs = S.mode !== 'kit' && hasSub(p);
    elTabs.hidden = !showTabs;
    elTabOne.textContent = CFG.tabOne || 'Achat unique';
    elTabSub.textContent = CFG.tabSub || 'Abonnement';
    elTabOne.setAttribute('aria-selected', S.mode === 'one' ? 'true' : 'false');
    elTabSub.setAttribute('aria-selected', S.mode === 'sub' ? 'true' : 'false');

    renderChoice();
    renderOffers();
    renderSizes();
    renderFoot();
    renderThumb();

    if (S.mode === 'kit') { elMore.hidden = true; }
    else {
      elMore.hidden = false;
      elMoreLink.textContent = CFG.moreLabel || 'Voir toute la fiche produit';
      elMoreLink.href = p.u;
    }
  }

  function setProduct(p) {
    S.p = p;
    if (S.key && !size(p, S.key)) S.key = null;
    if (S.mode === 'kit' && S.key && !kitVariant(p, size(p, S.key))) S.key = null;
    if (S.mode === 'sub' && !hasSub(p)) S.mode = 'one';
  }

  /* ---------- ouverture / fermeture ---------- */
  function open(mode, p, vid) {
    S.mode = mode;
    S.offer = mode === 'sub' ? 'bundle' : 'pack';
    S.key = null;
    if (mode === 'kit') setProduct(p || kitProducts()[0]);
    else setProduct(p || PRODUCTS[0]);
    if (mode === 'one' && vid) selectVariant(S.p, vid);
    render();
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var f = modal.querySelector('.qa-sz:not([disabled])');
    if (f) f.focus();
  }
  function close() {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest ? e.target.closest('[data-qa]') : null;
    if (add) {
      e.preventDefault();
      open('one', byHandle(add.getAttribute('data-qa')),
        add.getAttribute('data-qa-variant') || add.getAttribute('data-uni-variant'));
      return;
    }
    var kit = e.target.closest ? e.target.closest('[data-kit]') : null;
    if (kit && (kitOn || CFG.kitEnabled)) { e.preventDefault(); open('kit', null); return; }
    if (e.target.closest && e.target.closest('[data-close-qa]')) { e.preventDefault(); close(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
  });

  elTabs.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mode]');
    if (!b) return;
    S.mode = b.getAttribute('data-mode');
    S.offer = S.mode === 'sub' ? 'bundle' : 'pack';
    render();
  });

  /* ---------- ajout au panier ---------- */
  elAdd.addEventListener('click', function () {
    var p = S.p, sz = size(p, S.key);

    /* garde du kit : un seul par compte. Le kit est mis au panier d'abord,
       la connexion est demandee ensuite : le panier survit a la connexion. */
    if (S.mode === 'kit' && kitBlocked()) return;

    if (!sz) return;
    var item = null;
    if (S.mode === 'kit') {
      var kv = kitVariant(p, sz);
      if (!kv) {
        if (window.LFDM && LFDM.toast) LFDM.toast('Ce kit n\'est pas disponible dans cette taille');
        return;
      }
      /* quantité verrouillée à 1, ligne marquée pour le volet panier */
      item = { id: String(kv.id), quantity: 1, properties: { _kit: '1' } };
    } else if (S.mode === 'sub') {
      item = { id: String(sz.b.id), quantity: 1, selling_plan: String(sz.s.id) };
    } else {
      var v = S.offer === 'bundle' ? sz.b : sz.p;
      item = { id: String(v.id), quantity: 1 };
    }
    if (!item) return;

    var toLogin = S.mode === 'kit' && kitNeedsLogin();
    elAdd.disabled = true;
    var done = function () {
      elAdd.disabled = false;
      close();
      if (!toLogin) return;
      var u = (KIT && KIT.loginUrl) || '/account/login';
      u += (u.indexOf('?') >= 0 ? '&' : '?') + 'return_url=' +
        encodeURIComponent(location.pathname + location.search);
      window.location.href = u;
    };
    var fail = function () { elAdd.disabled = false; };
    var msg = S.mode === 'kit'
      ? (toLogin ? 'Kit d\'essai réservé — connectez-vous pour le recevoir' : 'Kit d\'essai ajouté')
      : 'Ajouté au panier';
    var go = function () {
      if (window.LFDM && LFDM.cartAdd) {
        LFDM.cartAdd(item, msg).then(done, fail);
      } else {
        done();
      }
    };
    /* un seul kit dans le panier : on retire l'éventuel kit déjà présent
       (permet de changer de gamme ou de taille sans doublon) */
    if (S.mode === 'kit' && window.LFDM && LFDM.kitClear) LFDM.kitClear().then(go, go);
    else go();
  });

  /* ---------- second visuel au tap (tactile) ---------- */
  if (window.matchMedia && !window.matchMedia('(hover:hover)').matches) {
    document.querySelectorAll('.prod-media').forEach(function (m) {
      m.addEventListener('click', function (e) {
        if (!m.classList.contains('show-2')) { e.preventDefault(); m.classList.add('show-2'); }
      });
    });
  }

  /* ---------- kit déjà utilisé : on le retire du panier ---------- */
  if (kitOn && KIT.used && window.LFDM && LFDM.kitClear) {
    LFDM.kitClear().then(function () { if (LFDM.cartRefresh) LFDM.cartRefresh(); });
  }

  /* ---------- barre d'achat mobile ---------- */
  var bar = document.getElementById('lfdmStickyCta');
  if (bar) {
    var onScroll = function () { bar.classList.toggle('is-on', window.scrollY > 600); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();